var desktop = false, mobile = false;

function window_large(){
	var window_width = $(window).width();
	if(window_width >= 900){
		if (desktop == false){
			mobile = false;
			desktop = true;
			$('#header-nav').show();
		}
	} else if(window_width < 900) {
		if (mobile == false) {
			mobile = true;
			desktop = false;
		}
	}
}

window_large();
function resize() {
	 window_large();
}
var TO = false;
$(window).resize(function(){
	if(TO !== false)
	   	clearTimeout(TO);
	TO = setTimeout(resize, 20); //200 is time in miliseconds
});

$(function () {
	$("#nav-toggle a").click(function(e){
		$("#header-nav").slideToggle();
		e.preventDefault();
	});
})
